import Controller, { OnAfterFetch, OnClose } from '@philips-internal/oswald-ui-core/lib/client';
import BaseController from '../../BaseController';
import { Inject } from '@odinjs/odin';
import { Endpoint } from '../../../constants/endpoints';
import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { ApplicationRoute } from '../../../constants/routes';
import { FetchEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { ButtonAPI, CheckboxAPI } from '@philips-internal/oswald-ui-components';
import { HasUserTerms } from '../../../types/terms';

interface PrivacyNoticeData {
  dsTermo: string;
  nrSequencia: number;
}

@Controller({ component: 'panel-general', fragment: 'privacy-notice' })
class PrivacyNoticeController extends BaseController {

  @Inject('checkbox-agree')
  checkBoxAgree!: CheckboxAPI;

  @Inject('button-confirm')
  buttonConfirm!: ButtonAPI;

  privacyNoticeResponse!: PrivacyNoticeData;

  @OnAfterFetch({ target: 'fetch-privacy-notice' })
  onAfterFetchTerms(e: FetchEvent): void {
    this.privacyNoticeResponse = e.data as PrivacyNoticeData;
  }

  @OnClose({ target: ['modal-content'] })
  onClose(): void {
    const { nrSequencia } = this.privacyNoticeResponse;
    HttpService.post(Endpoint.PRIVACY_NOTICE_ACCEPTED, { nrSequencia })
      .then(() => HttpService.get(Endpoint.HAS_USER_TERMS))
      .then((response) => {
        const body = response.body as HasUserTerms;

        /* hasTermsOfUse indicates whether the user has accepted the terms of use or not.
           When true, redirects to main menu, because the user has already accepted;
           otherwise, loads the terms page so the user needs to accept them. */
        if (body.hasTermsOfUse) {
          this.historyService.push(ApplicationRoute.SPOTLIGHT);
        } else {
          this.historyService.push(ApplicationRoute.TERMOS_OF_USE);
        }
      });
  }
}

export default PrivacyNoticeController;
